// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iU4gQAQFszAx9CrmVhP3 {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 24px;
}
.iU4gQAQFszAx9CrmVhP3:last-child {
  margin-bottom: 0;
}

.n_DPXP8IHyZVjY_gjI0v {
  width: 302px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
}

.SLimrOdDiBenNrZMGZvG {
  font-family: var(--font-stack-full-medium);
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 500;
  color: var(--grey-color-90);
}

.vE7DNxqVsu4Ujnokbfb3 {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.p85FprRBYnsiY10K221l {
  flex: 1 1 48%;
  margin-right: 32px;
}

.zGRQytxmgZ8ieF8KRbyv {
  display: flex;
}

.hFqQAeoXyjnkewlPADiY {
  width: 100%;
  margin-top: 6px;
}

.hd3ipOnIjczxUoZXm3t4 {
  flex: 1 1 48%;
}

.R7bhj16KjVlcYW3Wigig {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.lR6z1cWlGcV4zQMycNvj {
  width: 100%;
  margin: 24px 0 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.yBeVHqqYnBZT7OmDnT7Z {
  width: 240px;
}

.ce8Bo8mXA9Xvlh88kmRp {
  flex: 1 1 auto;
  display: flex;
}

.iuamKOWUlI97wqXDFN5l {
  flex: 1 1 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 32px;
}

.Ds7SDZFQJwrWOPwxJevH {
  height: 1px;
  margin: 18px 0 24px;
  background-color: var(--grey-color-200);
}`, "",{"version":3,"sources":["webpack://./src/components/SwiftFactorChart/SwiftFactorChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,mBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,uCAAA;AACF","sourcesContent":[".skillsTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin-bottom: 24px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.scoreLabelContainer {\n  width: 302px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  cursor: pointer;\n}\n\n.scoringLabel {\n  font-family: var(--font-stack-full-medium);\n  line-height: 1.5;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--grey-color-90);\n}\n\n.averageAndDistributionBox {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.averageScoreBox {\n  flex: 1 1 48%;\n  margin-right: 32px;\n}\n\n.mainTitleContainer {\n  display: flex;\n}\n\n.titleAverageDistributionContainer {\n  width: 100%;\n  margin-top: 6px;\n}\n\n.distributionLevelMainBoxesContainer {\n  flex: 1 1 48%;\n}\n\n.boxMainTitle {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.secondTitleMainBox {\n  width: 100%;\n  margin: 24px 0 12px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.emptyFirstBox {\n  width: 240px;\n}\n\n.averageAndDistributionTitleContainer {\n  flex: 1 1 auto;\n  display: flex;\n}\n\n.averageScoreAndTargetContainer {\n  flex: 1 1 48%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.dividerLine {\n  height: 1px;\n  margin: 18px 0 24px;\n  background-color: var(--grey-color-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skillsTitleContainer": `iU4gQAQFszAx9CrmVhP3`,
	"scoreLabelContainer": `n_DPXP8IHyZVjY_gjI0v`,
	"scoringLabel": `SLimrOdDiBenNrZMGZvG`,
	"averageAndDistributionBox": `vE7DNxqVsu4Ujnokbfb3`,
	"averageScoreBox": `p85FprRBYnsiY10K221l`,
	"mainTitleContainer": `zGRQytxmgZ8ieF8KRbyv`,
	"titleAverageDistributionContainer": `hFqQAeoXyjnkewlPADiY`,
	"distributionLevelMainBoxesContainer": `hd3ipOnIjczxUoZXm3t4`,
	"boxMainTitle": `R7bhj16KjVlcYW3Wigig`,
	"secondTitleMainBox": `lR6z1cWlGcV4zQMycNvj`,
	"emptyFirstBox": `yBeVHqqYnBZT7OmDnT7Z`,
	"averageAndDistributionTitleContainer": `ce8Bo8mXA9Xvlh88kmRp`,
	"averageScoreAndTargetContainer": `iuamKOWUlI97wqXDFN5l`,
	"dividerLine": `Ds7SDZFQJwrWOPwxJevH`
};
export default ___CSS_LOADER_EXPORT___;
